import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const ImageDividerContainer = styled.div<{
  enableMaxWidth?: boolean;
}>`
  text-align: center;
  margin-top: 0;
  margin-bottom: ${theme.spacing['3xl']};

  img {
    max-width: ${({ enableMaxWidth }) => (enableMaxWidth ? '100%' : 'inherit')};
    max-height: 150px;
    ${({ enableMaxWidth }) => (enableMaxWidth ? 'object-fit: contain !important' : '')};
  }

  ${media.tablet`
    margin-bottom: 80px;
  `}

  ${media.desktop`
    margin-bottom: 120px;
  `}
`;

